import React from 'react';
import { Redirect, Route, Switch } from 'react-router';
import { ThemeProvider } from 'styled-components';
import Page from '@/se/components/Page';
import Sidebar from '@/se/components/Sidebar';
import ChangePassword from '../ChangePassword';
import Header from '../admin/Header';
import Footer from '../admin/Footer';
import { dark as darkTheme } from '../../../../theme';
import { Context as PatientNameFormatContext } from '../../../../contexts/PatientNameFormat';
import { withSession } from '../../../../state/Session';
import get from 'lodash/fp/get';
import SensorPage from '../../sensor/SensorPage';
import Training from '../../training/Training';
import { muiThemeDark } from '../../../../muiTheme';
import { ThemeProvider as MUIThemeProvider } from '@material-ui/styles';
import { MainContainer } from '../../MainContainer';
import { CssBaseline } from '@material-ui/core';
import { OmniSearchProvider, OmniSearchSources } from '../../../OmniSearch';
import activeAndPastProceduresSource from '../../../../omnisearch/sources/hospital/activeAndPastProcedures';
import scheduledProceduresSource from '../../../../omnisearch/sources/hospital/scheduledProcedures';
import { Event, InvertColors, Theaters, VideoLabel } from '@material-ui/icons';
import { useScope } from '../../../../hooks/useScope';
import ExternalSchedule from '../../ExternalSchedule';

const getRoutes = organizationId => [
  {
    path: `/sensors`,
    to: `/sensors`,
    label: 'Temp & Humidity',
    icon: <InvertColors />,
    component: SensorPage,
  },
  { separator: true },
  {
    path: `/kiosk/${organizationId}/monitor`,
    to: `/kiosk/${organizationId}/monitor`,
    target: '_blank',
    label: 'Operations Screen',
    icon: <VideoLabel />,
  },
  {
    path: `/schedule`,
    to: `/schedule`,
    label: 'OR Schedule Screen',
    icon: <Event />,
    component: ExternalSchedule,
  },
  { separator: true },
  {
    path: `/training`,
    to: `/training`,
    label: 'Video Tutorials',
    icon: <Theaters />,
    component: Training,
  },
];

const SensorSidebar = () => {
  const scope = useScope();
  const organizationId = scope?.hospital?.id;
  return <Sidebar Header={Header} Footer={Footer} links={getRoutes(organizationId)} />;
};

const Homepage = ({ patientNameFormat }) => {
  const scope = useScope();
  const organizationId = scope?.hospital?.id;
  const routes = getRoutes(organizationId).filter(route => route.component);

  return (
    <ThemeProvider theme={darkTheme}>
      <MUIThemeProvider theme={muiThemeDark}>
        <style>
          {`body {
          background: ${muiThemeDark.palette.background.default};
        }`}
        </style>
        <CssBaseline />
        <PatientNameFormatContext.Provider value={patientNameFormat}>
          <OmniSearchProvider>
            <OmniSearchSources sources={[activeAndPastProceduresSource, scheduledProceduresSource]} />
            <Page Sidebar={SensorSidebar}>
              <MainContainer switchControl>
                <Switch>
                  {routes.map(({ path, component }, index) => (
                    <Route key={path || index} path={path} component={component} />
                  ))}
                  <Route path="/change-password" component={ChangePassword} />
                  <Route render={() => <Redirect to="/sensors" />} />
                </Switch>
              </MainContainer>
            </Page>
          </OmniSearchProvider>
        </PatientNameFormatContext.Provider>
      </MUIThemeProvider>
    </ThemeProvider>
  );
};

export default withSession(get('session.account.metadata'))(Homepage);
